import { Col, Form, Modal, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface RequestProposalAgainModalProps {
  visible1: boolean;
  requestProposalAgain: (value: any) => void;
  onCancelRrequestProposalAgain: () => void;
}

function RequestProposalAgainModal({
  visible1,
  requestProposalAgain,
  onCancelRrequestProposalAgain,
}: RequestProposalAgainModalProps) {
  const [form] = Form.useForm();

  return (
    <StyledDiv>
      <Modal
        visible={visible1}
        title="참가업체 상태 변경"
        okText="확인"
        cancelText="취소"
        onCancel={onCancelRrequestProposalAgain}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              requestProposalAgain(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Row justify="center">
            <Col span={12}>
              <Form form={form} initialValues={{}} layout="vertical">
                <Form.Item
                  name="reason"
                  label="재견적 요청 이유"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <TextArea
                    style={{ width: '100%' }}
                    rows={4}
                    placeholder="재견적 요청 이유를 입력하세요."
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default RequestProposalAgainModal;
